export const SkillItemStyle = {
  textField: {
    marginLeft: '16px',
    backgroundColor: 'transparent',
    color: 'text.secondary',
  },
  input: {
    color: 'text.secondary',
  },
  errorInput: {
    backgroundColor: 'transparent',
  },
  listItem: {
    backgroundColor: 'transparent',
  },
  errorListItem: {
    backgroundColor: 'rgba(209, 67, 67, 0.12)',
  },
  rating: {
    marginLeft: '18px',
    marginRight: '18px',
  },
  removeButton: {
    style: {
      cursor: 'pointer',
      marginLeft: 'auto',
    },
    sx: {
      color: 'text.secondary',
    },
  },
  label: {
    style: {
      fontSize: '12px',
      lineHeight: '12px',
      letterSpacing: '0.15px',
    },
    sx: {
      color: 'text.secondary',
    },
  },
};
